import { Route, Routes } from "react-router-dom";
import Countries from "./router/countries/countries.router";
import Home from "./router/home/home.router";
import Navigation from "./router/navigation/navigation.router";
const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigation />}>
        <Route index element={<Home />} />
        <Route path="countries/*" element={<Countries />} />
      </Route>
    </Routes>
  );
};

export default App;
